import React from "react";
import LegalTextPage from "../legal/LegalTextPage";
import { addPolicy, getPolicy } from "../../../services/settings";

const Privacy = () => (
  <LegalTextPage
    load={getPolicy}
    field="policies"
    save={addPolicy}
    texts={{
      title: "Privacy Policy",
      empty: "Please Enter Privacy Policy First!",
      saved: "Privacy Policy Added Successfully !",
      failed: "Adding Policy Failed!",
    }}
  />
);

export default Privacy;
